import { useState } from "react";
import { Modal } from "./dialog.tsx";
import { Alert, Button, PasswordField, TextField } from "./ui.tsx";
import { ApiError, post } from "../lib/api.ts";
import type { SessionDto } from "../../shared/auth.ts";

/** Session expired while editing: sign in again without leaving the page, so the unsaved buffer survives. */
export function ReloginDialog({ email, onDone, onGiveUp }: { email: string; onDone: (s: SessionDto) => void; onGiveUp: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function submit() {
    setBusy(true);
    setError(null);
    try {
      const res = await post<{ data: SessionDto }>("/auth/login", { email, password });
      onDone(res.data);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Não foi possível entrar agora.");
    } finally {
      setBusy(false);
    }
  }
  return (
    <Modal open onOpenChange={() => {}} title="Sua sessão terminou"
      description="Entre novamente para continuar. Suas alterações continuam na tela; depois, salve outra vez."
      footer={<><Button variant="secondary" onClick={onGiveUp} disabled={busy}>Descartar e sair</Button><Button loading={busy} onClick={() => void submit()}>Entrar e continuar</Button></>}>
      {error && <Alert tone="danger">{error}</Alert>}
      <form noValidate onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <TextField label="E-mail" value={email} readOnly />
        <PasswordField label="Senha" autoComplete="current-password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit" className="hidden" />
      </form>
    </Modal>
  );
}
